// extracted by mini-css-extract-plugin
export var header = "_sn-1";
export var maskBottom = "_sn-6";
export var maskMiddle = "_sn-7";
export var maskTop = "_sn-5";
export var root = "_sn-0";
export var scrollDownButton = "_sn-3";
export var scrollDownButtonHidden = "_sn-4";
export var viewport = "_sn-2";